import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const base =
  "group relative inline-flex items-center gap-3 rounded-full font-mono text-xs uppercase tracking-[0.25em] transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#06B6D4] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0B0C10]";

const inner =
  "flex items-center gap-3 rounded-full bg-[#0B0C10]/85 px-8 py-4 text-[#F4F6FB] backdrop-blur-xl transition-colors duration-300 group-hover:bg-transparent group-hover:text-[#0B0C10]";

const Content = ({ children }) => (
  <>
    {children}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
  </>
);

export const PrimaryCTA = ({ to, href, onClick, children, testId, ...rest }) => {
  const cls = `${base} bg-gradient-to-r from-[#8B5CF6] to-[#06B6D4] p-px`;
  const body = (
    <span className={inner}>
      <Content>{children}</Content>
    </span>
  );
  if (to) {
    return (
      <Link to={to} data-testid={testId} className={cls} {...rest}>
        {body}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} data-testid={testId} className={cls} {...rest}>
        {body}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} data-testid={testId} className={cls} {...rest}>
      {body}
    </button>
  );
};

export const GhostCTA = ({ to, href, onClick, children, testId, ...rest }) => {
  const cls = `${base} border border-white/15 bg-white/5 px-8 py-4 text-[#F4F6FB] backdrop-blur-xl hover:border-[#8B5CF6]/60 hover:bg-[#8B5CF6]/15`;
  if (to) {
    return (
      <Link to={to} data-testid={testId} className={cls} {...rest}>
        <Content>{children}</Content>
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} data-testid={testId} className={cls} {...rest}>
        <Content>{children}</Content>
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} data-testid={testId} className={cls} {...rest}>
      <Content>{children}</Content>
    </button>
  );
};
